export default {
    mineReports(state) {
        return state.mineReports;
    },
    reportCenterReports(state) {
        return state.reportCenterReports;
    },
    otherReports(state) {
        return state.otherReports;
    },
    upsertDefinition(state){
        return state.upsertDefinition;
    },
    reportFeeds(state){
        return state.reportFeeds;
    },
    uniqueAuthorChart(state){
        return state.uniqueAuthorChart;
    },
    engagements(state){
        return state.engagements;
    },
    categoryRates(state){
        return state.categoryRates;
    },
    sentimentChart(state){
        return state.sentimentChart;
    },
    socialMediaRates(state){
        return state.socialMediaRates;
    },
    interactionChart(state){
        return state.interactionChart;
    },
    locationChart(state){
        return state.locationChart;
    },
    talkRateChart(state){
        return state.talkRateChart;
    }    

}